import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { useTimeSettingsCategory } from 'modules/attendance/lib/timeSettingsCategoryContext'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'
import { TimeBlocksBalanceCollection } from 'modules/attendance/store/models/TimeBlocksBalanceCollection'

import Card from './Card'
import Header from './Header'

type Props = {
  timeBlocksBalance: TimeBlocksBalanceCollection
}

const Compensation = ({ timeBlocksBalance }: Props) => {
  const timeOffTransfers = timeBlocksBalance.timeOffTransfers
  const timeOffDiscardedTransfers = timeBlocksBalance.timeOffDiscardedTransfers
  const { featureByName } = useTimesheetData()

  const { timeSettingsCategories } = useTimeSettingsCategory()
  const timeSettingsCategoryById = groupBy(
    timeSettingsCategories.activeCategories,
    (category) => category.id
  )

  const {
    pendingPayrollBlocks,
    compensatedPayrollBlocks,
    payrollPendingMinutes,
    payrollCompensatedMinutes,
  } = timeBlocksBalance.payrollCompensationPendingAndCompensated

  const totalTransfersTimeOff = timeBlocksBalance.timeOffTransferMinutes

  const totalTransfers = payrollPendingMinutes + payrollCompensatedMinutes + totalTransfersTimeOff
  const hasExtraHourRules = TimesheetFeatures.EXTRA_HOUR_RULES in featureByName

  return (
    <Box gap="s16">
      <Header
        totalTransfers={totalTransfers}
        totalTransfersTimeOff={totalTransfersTimeOff}
        totalTransfersCompensatedPayroll={payrollCompensatedMinutes}
        totalTransfersPendingToCompensatePayroll={payrollPendingMinutes}
      />
      <Box paddingX="s24" gap="s24">
        <Box gap="s16">
          {totalTransfersTimeOff != 0 && (
            <Card
              compensationMethod={'timeoff'}
              transfers={timeOffTransfers}
              discardedTransfers={timeOffDiscardedTransfers}
              totalTransfersByPoolType={totalTransfersTimeOff}
              timeSettingsCategoryById={timeSettingsCategoryById}
              compensated
            />
          )}
          {payrollCompensatedMinutes > 0 && (
            <Card
              compensationMethod={'payroll'}
              transfers={compensatedPayrollBlocks}
              totalTransfersByPoolType={payrollCompensatedMinutes}
              timeSettingsCategoryById={timeSettingsCategoryById}
              compensated
            />
          )}
          {payrollPendingMinutes > 0 && (
            <Card
              compensationMethod={'payroll'}
              transfers={pendingPayrollBlocks}
              totalTransfersByPoolType={payrollPendingMinutes}
              timeSettingsCategoryById={timeSettingsCategoryById}
              compensated={false}
            />
          )}
        </Box>
        {totalTransfers > 0 && !hasExtraHourRules && (
          <Box paddingBottom="s32">
            <Text size="200" color="grey1000">
              {i18n.t('clock_in.sidepanel.compensation.footer')}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Compensation
